var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigureiconBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 32,
    viewBox: "0 0 38 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_2_432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.86473 13.9999C9.86473 12.8213 10.101 11.6542 10.5601 10.5653C11.0192 9.47642 11.6921 8.48702 12.5404 7.65362C13.3887 6.82021 14.3957 6.15912 15.5041 5.70808C16.6124 5.25705 17.8003 5.0249 19 5.0249C20.1997 5.0249 21.3876 5.25705 22.4959 5.70808C23.6043 6.15912 24.6113 6.82021 25.4596 7.65362C26.3079 8.48702 26.9808 9.47642 27.4399 10.5653C27.899 11.6542 28.1353 12.8213 28.1353 13.9999C28.1353 18.4749 29.0895 21.0749 29.9292 22.4999C30.0184 22.6517 30.0654 22.8238 30.0656 22.999C30.0658 23.1743 30.019 23.3465 29.9301 23.4984C29.8412 23.6503 29.7132 23.7766 29.559 23.8646C29.4048 23.9526 29.2297 23.9993 29.0513 23.9999H8.94866C8.77029 23.9993 8.59522 23.9526 8.44099 23.8646C8.28675 23.7766 8.15877 23.6503 8.06986 23.4984C7.98095 23.3465 7.93423 23.1743 7.93439 22.999C7.93455 22.8238 7.98157 22.6517 8.07076 22.4999C8.91049 21.0749 9.86473 18.4749 9.86473 13.9999Z",
    stroke: "url(#paint0_linear_2_432)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9286 24V25C14.9286 26.0609 15.3575 27.0783 16.1211 27.8284C16.8846 28.5786 17.9202 29 19 29C20.0798 29 21.1154 28.5786 21.879 27.8284C22.6425 27.0783 23.0714 26.0609 23.0714 25V24",
    stroke: "url(#paint1_linear_2_432)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0486 3C28.1211 4.28526 29.7937 6.10584 30.8835 8.2625",
    stroke: "url(#paint2_linear_2_432)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11652 8.2625C8.20629 6.10584 9.87891 4.28526 11.9513 3",
    stroke: "url(#paint3_linear_2_432)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_2_432",
    x: -2,
    y: -2,
    width: 42,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_432"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_432",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2_432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_432",
    x1: 19,
    y1: 5.0249,
    x2: 19,
    y2: 23.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_432",
    x1: 19,
    y1: 24,
    x2: 19,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_432",
    x1: 28.4661,
    y1: 3,
    x2: 28.4661,
    y2: 8.2625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.85
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_432",
    x1: 9.53393,
    y1: 3,
    x2: 9.53393,
    y2: 8.2625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.85
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigureiconBell);
export default __webpack_public_path__ + "static/media/figure.icon-bell.be2aed1b03d41f493aa18c2c574df1c0.svg";
export { ForwardRef as ReactComponent };